import EventEmitter from 'eventemitter3'
import RankingManager from './RankingManager'
import AssetsManager from '../data/AssetsManager'
import SpinnerView from '../view/SpinnerView'
import TimeUtil from '../util/TimeUtil'

/**
 * RankingViewクラス
 */
class RankingView extends EventEmitter{
  // ---------------------------------------------------------------------------------------------------------
  // --	RankingView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    // console.log('RankingView');
  }

  /**
   * 初期化
   */
  init()
  {
    //DOM参照
    this.container = $("#ranking");
    this.closeButton = this.container.find("a.closebutton");
    
    //ボタンアクション
    this.closeButton.on("click", (e) => {
      e.preventDefault();
      this.close();
    });
    
    //初期リセット
    this.reset();
  }

	/**
	* リセット
	**/
  reset()
  {
    //Tween停止
		TweenMax.killTweensOf(this.container);
		
    //初期非表示
    this.container.hide();
 		TweenMax.set(this.container, {top:"100%"});
 		
 		//リスト削除
 		$("ul li", this.container).each(function(index){
	 		$(this).remove();
 		});
  }

	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 開く
	// --------------------------------------------------------------------------------------------------------------------------------------
	
	/**
	* 開く
	**/
  open()
  {
    //コンテナ
    this.container.show();
    TweenMax.killTweensOf(this.container);
    TweenMax.set(this.container, {top:"100%"});
    TweenMax.to(this.container, 0.6, {top:"0%", ease:Power2.easeOut, onComplete:()=>{
      SpinnerView.show();
      RankingManager.on("success", this.onGetRankingSuccess.bind(this));
      RankingManager.on("error", this.onGetRankingFailed.bind(this));
      RankingManager.getRanking();
    }});
  }
  
  onGetRankingSuccess(results)
  {
    //リスナー削除
    RankingManager.off("success");
    RankingManager.off("error");
  
    //スピナー非表示
    SpinnerView.hide();

    //Config
    this.config = AssetsManager.getConfig();

    //結果表示
    if(results.length > 0)
    {
      for(let i=0; i<results.length; i++)
      {
        //モデル取得
        const model = results[i];

        let score;
        switch(this.config.SCORE_TYPE){
          case 'timer':
            const maxTime = 59*60000 + 59*1000 + 999;
            const spendTime = maxTime - model.score;
            score = TimeUtil.toTimeStr(spendTime);
            break;
          default:
            score = model.score;
        }

        //DOM追加
        this.container.find("ul").append('<li><div class="num">'+(i+1)+'</div><div class="name">'+model.username+'</div><div class="score">' + score + '<span class="pt">'+this.config.SCORE_UNIT+'</span></div></li>');
      }
    }
  }
  
  onGetRankingFailed(e)
  {
    //リスナー削除
    RankingManager.off("success");
    RankingManager.off("error");
  
    //スピナー非表示
    SpinnerView.hide();
  
    //アラート
    alert("エラーが発生しました：" + e.data);
  }

	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 閉じる
	// --------------------------------------------------------------------------------------------------------------------------------------
	
	/**
	* 閉じる
	**/
  close()
  {
    //コンテナ
    TweenMax.killTweensOf(this.container);
    TweenMax.to(this.container, 0.6, {top:"100%", ease:Power2.easeOut, onComplete:() => {
      this.reset();
    }});
  }
    
  // ---------------------------------------------------------------------------------------------------------
}

export default new RankingView()
